<template>
    <tr>
        <td>{{row.depth}}</td>
        <td class="moreInfo" @click="openMoreInformation">
            More info params
            <img :class="{ rotate: openMoreParamInfo }" src="../../assets/images/down-arrow.svg" alt="open">
        </td>
        <div :class="{ information_open: openMoreParamInfo}" class="information">
            <div class="information__wrapper">
                <div class="information__param" v-if="row.params.user_id">
                    UserId:
                    <span v-for="userId in row.params.user_id">
                        {{userId}}
                    </span>
                </div>
                <div class="information__param" v-if="row.params.username">
                    Username:
                    <span v-for="userName in row.params.username">
                        {{userName}}
                    </span>
                </div>
                <div class="information__param" v-if="row.params.ip">
                    Ip:
                    <span v-for="ip in row.params.ip">
                        {{ip}}
                    </span>
                </div>
                <div class="information__param" v-if="row.params.wallet">
                    Wallet:
                    <span v-for="wallet in row.params.wallet">
                        {{wallet}}
                    </span>
                </div>
                <div class="information__param" v-if="row.params.roblox_username">
                    Roblox Username:
                    <span v-for="robloxUserName in row.params.roblox_username">
                        {{robloxUserName}}
                    </span>
                </div>
                <div class="information__param" v-if="row.params.email">
                    Email:
                    <span v-for="email in row.params.email">
                        {{email}}
                    </span>
                </div>
                <div class="information__param" v-if="row.params.payment_system_invoice">
                    Payment system invoice:
                    <span v-for="payment in row.params.payment_system_invoice">
                        {{payment}}
                    </span>
                </div>
                <div class="information__param" v-if="row.params.withdrawl_id">
                    Withdrawl id:
                    <span v-for="withdraw in row.params.withdrawl_id">
                        {{withdraw}}
                    </span>
                </div>
                <div class="information__param" v-if="row.params.topup_id">
                    Topup id:
                    <span v-for="topup in row.params.topup_id">
                        {{topup}}
                    </span>
                </div>
            </div>
        </div>
    </tr>
</template>

<script>
export default {
    name: "TableRowRns",
    props: {
        row: {
            type: Object,
            require: true,
        }
    },
    data () {
        return {
            openMoreParamInfo: false
        }
    },
    methods: {
        openMoreInformation() {
            this.openMoreParamInfo = !this.openMoreParamInfo
        },
    }
}
</script>
